export default function isPacRimOrCarib(regionCode) {
    return regionCode === 'pacrim' || regionCode === 'caribbean';
}



// WEBPACK FOOTER //
// ./app/common/schedule/isPacRimOrCarib.js